function calculateBMI(heightInCm, gender) {
  let idealWeight;

  if (heightInCm > 152) {
    if (gender === 'male') {
      idealWeight = 48.0 + 1.1 * (heightInCm - 152);
    } else if (gender === 'female') {
      idealWeight = 45.4 + 0.9 * (heightInCm - 152);
    } else {
      throw new Error('Invalid gender. Please use "male" or "female".');
    }
  } else {
    if (gender === 'male') {
      idealWeight = (heightInCm - 100) - (0.1 * (heightInCm - 100));
    } else if (gender === 'female') {
      idealWeight = (heightInCm - 100) + (0.15 * (heightInCm - 100));
    } else {
      throw new Error('Invalid gender. Please use "male" or "female".');
    }
  }

  return idealWeight.toFixed(2);
}

function calculateTherapyDuration(num1, num2) {
  // Calculate the absolute difference
  const difference = Math.abs(num1 - num2);
  
  // Divide the difference by 0.25
  const result = difference / 0.25;
  
  return result;
}

// Helper function to convert Roman numerals to numbers
function romanToNumber(roman) {
  const romanNumerals = { I: 1, II: 2, III: 3, IV: 4 };
  return romanNumerals[roman] || 0;
}

function calculateAndReturnParams(stepen, percent, foot, split, romanStepen) {
  // console.log(stepen, "stepen");
  // console.log(percent, "persent");
  // console.log(foot, "foot");
  // console.log(split, "split");
  const numericStepen = romanToNumber(romanStepen);

  //console.log(numericStepen, "numericki stepen");
  const remainingPercent = stepen;
  //console.log(remainingPercent, "ostatak procenta");
  // Check if remainingPercent is <= 10 and numericStepen is > 1
  if (remainingPercent <= 10 && numericStepen > 1) {
    // Decrement numericStepen by 1 and append both values
    // console.log(
    //   `${foot}${split ? "p" : ""}${numericStepen}${numericStepen - 1}`,
    //   "1"
    // );
    return `${foot}${split ? "p" : ""}${numericStepen}${numericStepen - 1}`;
  } else if (remainingPercent >= 90 && numericStepen === 4) {
    // Check if remainingPercent is >= 90 and numericStepen is 4
    // If true, return ${numericStepen}${numericStepen}
    // console.log(
    //   `${foot}${split ? "p" : ""}${numericStepen}${numericStepen}`,
    //   "2"
    // );
    return `${foot}${split ? "p" : ""}${numericStepen}${numericStepen}`;
  } else if (remainingPercent >= 90 && numericStepen === 2) {
    return `${foot}${split ? "p" : ""}${numericStepen}${numericStepen + 1}`;
  } else if (remainingPercent >= 90 && numericStepen === 3) {
    return `${foot}${split ? "p" : ""}${numericStepen}${numericStepen + 1}`;
  } else {
    // Return the string with the original numericStepen
    console.log(
      `${foot}${split ? "p" : ""}${numericStepen}${numericStepen}`,
      "3"
    );
    return `${foot}${split ? "p" : ""}${numericStepen}${numericStepen}`;
  }
}

export { calculateBMI, calculateAndReturnParams, calculateTherapyDuration };
